import React, { useState, useEffect, forwardRef } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart as regularHeart } from "@fortawesome/free-regular-svg-icons";
import { faHeart as solidHeart } from "@fortawesome/free-solid-svg-icons";
import { FaSpinner } from "react-icons/fa";
import Aos from "aos";
import "aos/dist/aos.css";
import { Rating } from "./Product";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import LoginModal from "../../../../modal/LoginModal";
import RegisterModal from "../../../../modal/RegisterModal";
import ForgotPasswordModal from "../../../../modal/ForgotPasswordModal";
import VerifyOtpModal from "../../../../modal/VerifyOtpModal";
import "./productCard.css";
import { useTranslation } from "react-i18next";
import { useModal } from "../../../../hooks/ModalContext";

const ProductGridView = forwardRef(
  ({ product, showFilters, onAddToCart, onAddToWishlist, onRemoveWishlist }, ref) => {
    const {
      title,
      description,
      sales_price,
      id,
      averageRating,
      image,
    } = product;

    // Safely get first image or fallback
    const imageUrl = image || "https://royshop.in/assets/no-image.png";

    const { t } = useTranslation();
    // Redux state
    const { api_token } = useSelector((state) => state.auth);

    const [isAddedToCart, setIsAddedToCart] = useState(false);
    const [isFavorited, setIsFavorited] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const { activeModal, setActiveModal, emailForOtp, setEmailForOtp } = useModal();

    const { emailForOtp: emailForOtpLogin } = useSelector((state) => state.auth);
    const { emailForOtp: emailForOtpRegister } = useSelector(
      (state) => state.register
    );

    useEffect(() => {
      Aos.init({ duration: 1000 });
    }, []);

    const toggleFavorite = () => {
      if (!api_token) {
        toast.error(`${t("You_need_to_login_to_add_product_to_your_wishlist")}`, {
          hideProgressBar: true,
          position: 'bottom-right',
          theme: 'dark',

        });
        setActiveModal("login");
        return;
      }

      setIsFavorited(prev => {
        if (prev) onRemoveWishlist?.(product);
        else onAddToWishlist?.(product);
        return !prev;
      });
    };

    const handleAddToCart = () => {
      if (!api_token) {
        toast.error(`${t("You_need_to_login_to_add_product_to_your_cart")}`, {
          hideProgressBar: true,
          position: 'bottom-right',
          theme: 'dark',

        });
        setActiveModal("login");
        return;
      }

      setIsLoading(true);
      onAddToCart?.(product);
      setTimeout(() => {
        setIsAddedToCart(true);
        setIsLoading(false);
      }, 400);
    };

    const handleBuyNow = () => alert(`Buy Now clicked for ${title}`);

    return (
      <>
        <div ref={ref} className={`${showFilters ? "col-xl-6" : "col-6 col-xl-4"} col-12`}>
          <div
            className="card rounded-3 shadow-sm product-card position-relative bg-white list-view-card"
          >
            {/* ❤️ Favorite icon */}
            <FontAwesomeIcon
              icon={isFavorited ? solidHeart : regularHeart}
              className="favorite-icon"
              onClick={toggleFavorite}
            />

            {/* === LEFT: Product Image === */}
            <div className="product-image-container d-flex justify-content-center align-items-center p-3">
              <Link to={`/product/${id}`}>
                <img
                  className="card-img-top product-image"
                  alt='No Image'
                  onError={(e) => {
                    e.target.onerror = null; // prevents infinite loop
                    e.target.src = "https://amzio.de/api/uploads/products/no-thumbnail.png";
                  }}
                  src={imageUrl}
                />
              </Link>
            </div>

            {/* === RIGHT: Product Info === */}
            <div className="card-body d-flex flex-column justify-content-center align-items-center text-start">
              <Link to={`/product/${id}`}>
                {/* Title & Price Section */}
                <div className="mt-4">
                  <h6 className="card-title text-dark fw-bold mb-2">{title}</h6>

                  <div className="d-flex align-items-start mb-3">
                    <span className="fw-bold px-1">€{sales_price || 0}</span>
                    <Rating averageRating={averageRating || 3} totalReviews={120} />
                  </div>
                </div>
              </Link>
              {/* Buttons */}
              <div className="d-flex flex-column flex-sm-row pt-2 w-100">
                <button
                  className="btn-stylish me-2 d-flex align-items-center justify-content-center w-100"
                  onClick={handleAddToCart}
                  disabled={isLoading || isAddedToCart}
                  style={isAddedToCart ? { opacity: 0.5, cursor: "not-allowed" } : {}}
                >
                  {isLoading ? <FaSpinner className="spin" /> : isAddedToCart ? `${t("added_to_cart")}` : `${t("add_to_cart")}`}
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
);

export default ProductGridView;
